<template>
  <div class="grid-view">
    <div class="main-content">
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :config-module="configModule"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import $store from '@/store'
import StrUtils from '@/utils/StrUtils'
import { TenantUtil } from '@/class/cargo/model/utils/TenantUtil'

export default {
  name: 'AirDataGrid',
  components: {
  },
  props: {
    configModule: { type: String, default: '', required: true },
    showCreate: { type: Boolean, default: false },
    showModify: { type: Boolean, default: false },
    showApprove: { type: Boolean, default: false },
    showSelection: { type: Boolean, default: false },
    showAgent: { type: Boolean, default: false },
    gridOptions: { type: Object, default: () => {} },
    currency: { type: String, default: '' },
    allIn: { type: Boolean, default: false },
    rowData: { type: Array, default: () => [] }
  },
  data() {
    return {
      tenantUtil: {},
      gridParams: {},
      gridApi: null,
      columnDefs: [
        {
          headerName: ' ', maxWidth: 30, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('Pricing.PriceNo'), field: 'priceNo', colId: 'priceNo', width: 200,
          tooltipValueGetter: (params) => {
            return PriceUtils.priceNoTipFunc(params.data, this.tenantUtil)
          }
        },
        {
          headerName: this.$t('Pricing.POL'), field: 'pol', colId: 'pol', width: 200,
          tooltipValueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value,
              'englishName')
          }
        },
        {
          headerName: this.$t('Pricing.POD'), field: 'pod', colId: 'pod', width: 200,
          tooltipValueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value,
              'englishName')
          }
        },
        {
          headerName: this.$t('Pricing.Via'), field: 'via', colId: 'via', width: 200,
          tooltipValueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value,
              'englishName')
          }
        },
        {
          headerName: this.$t('Pricing.Flight'), field: 'serviceItem', colId: 'serviceItem', width: 200,
          valueFormatter: (params) => {
            const serviceItem = params.value.split(',')
            const newServiceItem = []
            serviceItem.map((item) => {
              const result = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_PriceServiceAir, 'code', item,
                $store.getters.language === 'zh' ? 'chineseName' : 'englishName')
              newServiceItem.push(result)
            })
            return newServiceItem
          }
        },
        {
          headerName: this.$t('Pricing.FlightNo'), field: 'flightNo', colId: 'flightNo', width: 200,
          tooltipValueGetter: (params) => {
            return params.value
          }
        },
        {
          headerName: this.$t('Pricing.Aircraft'), field: 'aircraft', colId: 'aircraft', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.aircraftLabelFunction(params.value)
          }
        },
        {
          headerName: this.$t('Pricing.Currency'), field: 'currency', colId: 'currency', width: 200
        },
        {
          headerName: this.$t('Pricing.weightVolume'), field: 'weightVolume', colId: 'weightVolume', width: 200,
          cellRenderer: (params) => {
            if (params.value !== '') {
              return `1: ${params.value}`
            }
          }
        },
        {
          headerName: 'M', field: 'minCharge', colId: 'minCharge', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.numberColumnLabelFunc_TACT(params, this.showCurrency, this.currency, this.allIn)
          }
        },
        {
          headerName: 'N', field: 'step', colId: 'step', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.numberColumnLabelFunc_TACT(params, this.showCurrency, this.currency, this.allIn)
          }
        },
        { headerName: '+45', field: 'p45', colId: 'p45', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.numberColumnLabelFunc_TACT(params, this.showCurrency, this.currency, this.allIn)
          } },
        { headerName: '+100', field: 'p100', colId: 'p100', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.numberColumnLabelFunc_TACT(params, this.showCurrency, this.currency, this.allIn)
          } },
        { headerName: '+300', field: 'p300', colId: 'p300', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.numberColumnLabelFunc_TACT(params, this.showCurrency, this.currency, this.allIn)
          } },
        { headerName: '+500', field: 'p500', colId: 'p500', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.numberColumnLabelFunc_TACT(params, this.showCurrency, this.currency, this.allIn)
          } },
        { headerName: '+1000', field: 'p1000', colId: 'p1000', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.numberColumnLabelFunc_TACT(params, this.showCurrency, this.currency, this.allIn)
          } },
        { headerName: this.$t('Pricing.Carrier_Air'), field: 'carrier', colId: 'carrier', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company,
              'cmpIdx', params.value, 'shortName')
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company,
              'cmpIdx', params.value, this.language)
          }
        },
        { headerName: this.$t('Pricing.Agent'), field: this.showAgent ? 'agent' : 'bookingAgent',
          colId: this.showAgent ? 'agent' : 'bookingAgent', width: 200,
          cellRenderer: (params) => {
            return this.bookingAgentLabelFunc(params.data, params.value)
          } },
        { headerName: this.$t('Pricing.DepartureDayOfAir'), field: 'frequency8', colId: 'frequency8', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.frequencyLabelFunc(params.data, 'frequency')
          }
        },
        { headerName: this.$t('Pricing.DepartureDayOfAir2'), field: 'isSecondFrequency', colId: 'isSecondFrequency', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.frequencyLabelFunc(params.data, 'secondFrequency')
          } },
        { headerName: this.$t('Pricing.Days'), field: 'days', colId: 'days', width: 200 },
        { headerName: this.$t('Pricing.CargoAircraft2'), field: 'secondAircraft', colId: 'secondAircraft', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.aircraftLabelFunction(params.value)
          }
        },
        { headerName: this.$t('Pricing.GroupNo'), field: 'groupNo', colId: 'groupNo', width: 200 },
        { headerName: this.$t('Pricing.BeginDateCol'), field: 'beginDate', colId: 'beginDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.EndDateCol'), field: 'endDate', colId: 'endDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.Branch'), field: 'branchId', colId: 'branchId', width: 200,
          hide: !this.showCreate, suppressColumnsToolPanel: !this.showCreate,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', params.value, 'code')
          } },
        { headerName: this.$t('Pricing.CreatedBy'), field: 'createdBy', colId: 'createdBy', width: 200,
          hide: !this.showCreate, suppressColumnsToolPanel: !this.showCreate,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.userToolTipLabel(params.value)
          } },
        { headerName: this.$t('Pricing.CreatedDate'), field: 'dateCreated', colId: 'dateCreated', width: 200,
          hide: !this.showCreate, suppressColumnsToolPanel: !this.showCreate,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.ModifiedBy'), field: 'modifiedBy', colId: 'modifiedBy', width: 200,
          hide: !this.showModify, suppressColumnsToolPanel: !this.showModify,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.userToolTipLabel(params.value)
          } },
        { headerName: this.$t('Pricing.ModifiedDate'), field: 'dateModified', colId: 'dateModified', width: 200,
          hide: !this.showModify, suppressColumnsToolPanel: !this.showModify,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.ApprovedBy'), field: 'modifiedBy', colId: 'modifiedBy', width: 200,
          hide: !this.showApprove, suppressColumnsToolPanel: !this.showApprove,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.userToolTipLabel(params.value)
          } },
        { headerName: this.$t('Pricing.ApprovedDate'), field: 'dateModified', colId: 'dateModified', width: 200,
          hide: !this.showApprove, suppressColumnsToolPanel: !this.showApprove,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Pricing.Remarks'), field: 'remarks', colId: 'remarks', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.remarkLabelFunc(params.data, params.value)
          }
        },
        { headerName: this.$t('Pricing.ROD'), field: 'region', colId: 'region', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.regionForPriceAirLabelFunc(params.data)
          }
        },
        { headerName: this.$t('SeaExport.PODCountry'), field: 'podCountry', colId: 'podCountry', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.airportCountryLabelFunc(params.data.pod)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.airportCountryLabelFunc(params.data.pod)
          }
        },
        { headerName: this.$t('Pricing.PodCity'), field: 'podCity', colId: 'podCity', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.airportCityLabelFunc(params.data.pod)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.airportCityLabelFunc(params.data.pod)
          }
        }
      ]
    }
  },
  computed: {
    language() {
      return this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.tenantUtil = await TenantUtil.getInstance()
    },
    bookingAgentLabelFunc(data, value) {
      if (value === null) return ''
      const sourcePriceUuid = data.sourcePriceUuid
      if (!StrUtils.isEmpty(sourcePriceUuid)) {
        return this.tenantUtil.getTenantNameById(value)
      } else {
        if (this.showAgent) {
          const d = ColumnUtils.companyLabelFun(Number(value), this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName', 'cmpIdx')
          if (d) {
            return d
          }
          return value
        } else {
          return ColumnUtils.companyLabelFun(value, this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName', 'cmpIdx')
        }
      }
    }
  }
}
</script>
<style lang="scss">
</style>

